import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import "./CourseSubscription.scss";
import { Input } from "components/Form";
import { BiRupee } from "react-icons/bi";
import { Select, TextArea } from "components/Form";
import { updateUserProfile } from "services/dashboard";

import {
  Link,
  useLocation,
  useNavigate,
  useNavigationType,
  useParams,
} from "react-router-dom";
import UploadDoc from "dashboard/edit-profile/UploadDoc";
import { toast } from "react-hot-toast";
import { userProfile } from "services/dashboard";
import { getCoupons } from "services/courses/coupons";
import {
  getBillingCourseDetailById,
  websiteVisitPageLog,
} from "services/courses/courses";
import useButtonLoader from "hooks/useButtonLoader";
import Payment from "./section/Payment";
import { useAddons } from "context/context";
import CourseSubscriptionSkeleton from "components/skeleton/CourseSubscriptionSkeleton";
import { FaTimesCircle } from "react-icons/fa";
import { errorResponse, failResponse } from "config/config";
import { CourseBookImg } from "assets/images";
import { FcTabletAndroid } from "react-icons/fc";
import useDebounce from "hooks/useDebounce";
import { getCourseVerticals, getAllStates } from "services/master";
import UploadCourseSubScription from "dashboard/edit-profile/UploadCourseSubscription";
import { isLoggedIn } from "config/utils";

function CourseSubscription() {
  const { courseName, courseId, centerid } = useParams();
  const decodedName = decodeURIComponent(courseName);
  const location = useLocation();
  const navType = useNavigationType();
  const navigate = useNavigate();
  const [couponToggle, setCouponToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [coupon, setCoupon] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState("");
  const [couponList, setCouponList] = useState([]);
  const isEffectRun = useRef(false);

  const [tabData, setTabData] = useState([]);
  const [tablet, setTablet] = useState(true);

  const debouncedTablet = useDebounce(tablet);

  const [isReadOnly, setIsReadOnly] = useState(false);

  const [buttonRef2, setButtonLoading2] = useButtonLoader("Proceed to payment");

  const [courseDetails, setCourseDetails] = useState({
    admissionCenter: "",
    conveyanceFee: 0,
    couponCode: "",
    couponCodeApplied: 0,
    courseFee: 0,
    gst: 0,
    isOldStudent: 0,
    newStudentCourseFee: 0,
    oldStudentCourseFee: 0,
    title: " English",
    total: 0,
    gstFee: 0,
  });

  // New: selected device option for new design (courseFeesData)
  const [selectedDevice, setSelectedDevice] = useState("tab");

  // ✅ NEW: selected variant for courseVariants flow
  const [selectedVariant, setSelectedVariant] = useState(null);

  const { addons } = useAddons();
  const [buttonRef, setSubmitLoading] = useButtonLoader("Apply");

  const [isEditable, setIsEditable] = useState({
    idProof: false,
    addressProof: false,
    idphoto: false,
    DOBCertificate: false,
    HSCCertificate: false,
  });

  const [userData, setUserData] = useState({});
  const [mobError, setMobError] = useState("");
  const [emobError, seteMobError] = useState("");

  const [errorField, setErrorField] = React.useState({
    firstName: "",
    lastName: "",
    Mobile: "",
    EmergencyContactNo: "",
    Education: "",
    PHouseNo: "",
    PStreet: "",
    PLandmark: "",
    PCity: "",
    PState: "",
    PZipCode: "",
    THouseNo: "",
    TStreet: "",
    TLandmark: "",
    TCity: "",
    TState: "",
    TZipCode: "",
  });

  const [isSameAddress, setIsSameAddress] = React.useState(
    userData.PHouseNo === userData.THouseNo &&
      userData.PStreet === userData.TStreet &&
      userData.PLandmark === userData.TLandmark &&
      userData.PCity === userData.TCity &&
      userData.PState === userData.TState &&
      userData.PZipCode === userData.TZipCode,
  );

  // ✅ Helper: courseVariants exist karte hain?
  const courseVariantsList = courseDetails?.courseVariants || [];
  const hasVariants = courseVariantsList.length > 0;

  // ✅ Helper: selected variant ki price
  const variantNewPrice = selectedVariant
    ? parseFloat(selectedVariant.newstdprice)
    : null;
  const variantOldPrice = selectedVariant
    ? parseFloat(selectedVariant.oldstdprice)
    : null;
  const variantSaving =
    variantOldPrice && variantNewPrice && variantOldPrice > variantNewPrice
      ? variantOldPrice - variantNewPrice
      : 0;

  // ✅ NEW: selected variant pe coupon apply hua hai ya nahi (API response se)
  const isVariantCouponApplied =
    hasVariants &&
    !!selectedVariant &&
    !!appliedCoupon &&
    courseDetails?.couponCodeApplied === 1 &&
    courseDetails?.variantCode === selectedVariant.variantcode;

  // ✅ Helper: effective total for payment
  const getEffectiveTotal = () => {
    if (hasVariants && selectedVariant) {
      // ✅ NEW: coupon apply hai to API ka total (coupon ke baad wala) use karo
      if (isVariantCouponApplied && courseDetails.total != null) {
        return parseFloat(courseDetails.total);
      }

      // ✅ Check isOldStudent for variant pricing
      if (courseDetails.isOldStudent === 1) {
        // Old student → show oldstdprice
        return parseFloat(selectedVariant.oldstdprice || 0);
      } else {
        // New student → show newstdprice
        return parseFloat(selectedVariant.newstdprice || 0);
      }
    }

    // Existing logic for courseFeesData
    const feesData = courseDetails?.courseFeesData;
    if (feesData) {
      if (selectedDevice === "tab")
        return parseFloat(feesData.tabnewstudentfees || 0);
      if (selectedDevice === "mob")
        return parseFloat(feesData.mobnewstudentfees || 0);
      if (selectedDevice === "byod")
        return parseFloat(feesData.byodnewstudentfees || 0);
    }

    // Old design fallback
    return courseDetails.total || 0;
  };
  const effectiveTotal = getEffectiveTotal();

  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    if (!userData.firstName) {
      errorField["firstName"] = "Please Enter First Name";
      formIsValid = false;
    }
    if (!userData.lastName) {
      errorField["lastName"] = "Please Enter Last Name";
      formIsValid = false;
    }
    if (!userData.Mobile) {
      errorField["Mobile"] = "Please Enter Mobile No.";
      formIsValid = false;
    }
    if (!userData.EmailID) {
      errorField["EmailID"] = "Please Enter Email ID";
      formIsValid = false;
    }
    if (!userData.EmergencyContactNo) {
      errorField["EmergencyContactNo"] = "Please Enter Emergency No.";
      formIsValid = false;
    }
    if (!userData.Education) {
      errorField["Education"] = "Please Enter Education";
      formIsValid = false;
    }
    // Address fields are hidden from UI now, so they are not required anymore.
    // Commented out (not removed) as requested.
    // if (!userData.PHouseNo) {
    //   errorField["PHouseNo"] = "Please Enter House No.";
    //   formIsValid = false;
    // }
    // if (!userData.PStreet) {
    //   errorField["PStreet"] = "Please Enter Street Name";
    //   formIsValid = false;
    // }
    // if (!userData.PLandmark) {
    //   errorField["PLandmark"] = "Please Enter Landmark";
    //   formIsValid = false;
    // }
    // if (!userData.PCity) {
    //   errorField["PCity"] = "Please Enter City";
    //   formIsValid = false;
    // }
    // if (!userData.PState) {
    //   errorField["PState"] = "Please Enter State";
    //   formIsValid = false;
    // }
    // if (!userData.PZipCode) {
    //   errorField["PZipCode"] = "Please Enter Zipcode";
    //   formIsValid = false;
    // }
    // if (!userData.THouseNo) {
    //   errorField["THouseNo"] = "Please Enter House No.";
    //   formIsValid = false;
    // }
    // if (!userData.TStreet) {
    //   errorField["TStreet"] = "Please Enter Street Name";
    //   formIsValid = false;
    // }
    // if (!userData.TLandmark) {
    //   errorField["TLandmark"] = "Please Enter Landmark";
    //   formIsValid = false;
    // }
    // if (!userData.TCity) {
    //   errorField["TCity"] = "Please Enter City";
    //   formIsValid = false;
    // }
    // if (!userData.TState) {
    //   errorField["TState"] = "Please Enter State";
    //   formIsValid = false;
    // }
    // if (!userData.TZipCode) {
    //   errorField["TZipCode"] = "Please Enter Zipcode";
    //   formIsValid = false;
    // }
    // Documents are hidden from UI now, so they are not required anymore.
    // Commented out (not removed) as requested.
    // if (isEditable.idProof) {
    //   formIsValid = false;
    // }
    // if (isEditable.addressProof) {
    //   formIsValid = false;
    // }
    // if (isEditable.idphoto) {
    //   formIsValid = false;
    // }

    setErrorField(errorField);
    return formIsValid;
  };

  //   onchange handler for edit profile
  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    const sanitizeInput = (name, value) => {
      let updatedValue = value;

      if (["TZipCode", "PZipCode", "EmergencyContactNo"].includes(name)) {
        updatedValue = value.replace(/\D/g, "");
      }
      if (["TCity", "PCity"].includes(name)) {
        updatedValue = value.replace(/[^A-Za-z ]/g, "").replace(/\s+/g, " ");
      }
      if (["TState", "PState"].includes(name)) {
        updatedValue = value.replace(/[^A-Za-z &-]/g, "").replace(/\s+/g, " ");
      }
      return updatedValue;
    };

    if (name === "Mobile") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length === 10) {
        setMobError("");
      } else {
        setMobError("Mobile number must be 10 digits");
      }
    }
    if (name === "EmergencyContactNo") {
      const numericValue = value.replace(/\D/g, "");
      if (numericValue.length === 10) {
        seteMobError("");
      } else {
        seteMobError("Mobile number must be 10 digits");
      }
    }

    const sanitizedValue = sanitizeInput(name, value);

    setUserData((prevUserData) => ({
      ...prevUserData,
      [name]: sanitizedValue,
    }));

    if (
      isSameAddress &&
      [
        "THouseNo",
        "TState",
        "TCity",
        "TZipCode",
        "TLandmark",
        "TStreet",
      ].includes(name)
    ) {
      setIsSameAddress(false);
    }
  };

  const handleProfileUpdate = async () => {
    const res = await updateUserProfile({
      firstName: userData.firstName,
      middleName: userData.middleName,
      lastName: userData.lastName,
      Mobile: userData.Mobile,
      EmergencyContactNo: userData.EmergencyContactNo,
      Education: userData.Education,
      // Address fields are hidden from UI now. Payload shape is unchanged,
      // but if data is not present we send empty string "" instead of
      // blocking/requiring it.
      PHouseNo: userData.PHouseNo || "",
      PStreet: userData.PStreet || "",
      PLandmark: userData.PLandmark || "",
      PCity: userData.PCity || "",
      PState: userData.PState || "",
      PZipCode: userData.PZipCode || "",
      THouseNo: userData.THouseNo || "",
      TStreet: userData.TStreet || "",
      TLandmark: userData.TLandmark || "",
      TCity: userData.TCity || "",
      TState: userData.TState || "",
      TZipCode: userData.TZipCode || "",
    });

    if (res.code === 200) {
    } else {
    }
    setSubmitLoading(false);
  };

  useEffect(() => {
    localStorage.setItem("supcoursename", "supcoursenameremove");
    localStorage.setItem("supcourseid", "supcourseidremove");
    if (userData) {
      handleProfileUpdate();
    }
  }, [userData]);

  const getUserProfile = async () => {
    try {
      const res = await userProfile();
      const {
        IDProof,
        addressProof,
        IDPhoto,
        DOBCertificate,
        HSCCertificate,
        ...rest
      } = userData;
      if (res.code === 200) {
        setUserData({ ...res.data.userDetails, ...rest } || {});
        setIsEditable({
          idProof: res.data.userDetails.IDProof ? false : true,
          addressProof: res.data.userDetails.addressProof ? false : true,
          idphoto: res.data.userDetails.IDPhoto ? false : true,
          DOBCertificate: res.data.userDetails.DOBCertificate ? false : true,
          HSCCertificate: res.data.userDetails.HSCCertificate ? false : true,
        });
      } else {
        failResponse(res);
      }
    } catch (err) {
      errorResponse(err);
    }
  };

  const getBillingCourseDetail = async (
    couponCode = coupon,
    isTab = 0,
    variantCode = null
  ) => {
    try {
      setButtonLoading2(true);
      const selectedAddons = addons[courseId];
      const res = await getBillingCourseDetailById({
        courseid: courseId,
        couponCode,
        addon_ids: selectedAddons?.map((data) => data.id),
        purchase_tab: isTab,
        // ✅ NEW: selected variant ka code (sirf tab jaayega jab variant selected ho)
        ...(variantCode ? { variantcode: variantCode } : {}),
      });

      if (res.code === 200) {
        setCourseDetails(res.data.data || {});
        setTabData(res.data.tabData || []);
        setButtonLoading2(false);
      } else if (res.code === 101) {
        failResponse(res);
        setCoupon("");
        setAppliedCoupon("");
        getBillingCourseDetail("", 0, variantCode);
        setButtonLoading2(false);
      } else {
        failResponse(res);
        setButtonLoading2(false);
      }
    } catch (err) {
      setButtonLoading2(false);
      errorResponse(err);
    }
  };

  const couponApplyHandler = async (coupon) => {
    if (!coupon) {
      toast.error("Please Enter Coupon Code");
    } else {
      setCoupon(coupon);
      setAppliedCoupon(coupon);
      setSubmitLoading(true);
      // ✅ NEW: apply coupon pe selected variant ka variantcode bhejo
      await getBillingCourseDetail(
        coupon,
        0,
        selectedVariant?.variantcode || null
      );
      setSubmitLoading(false);
    }
  };

  // ✅ variant select: API call nahi hoti. Variant badalne par purana coupon clear hota hai,
  // user ko naye variant ke liye Apply button dabana padega (tabhi API call hogi)
  const handleVariantSelect = (variant) => {
    if (selectedVariant?.id !== variant.id) {
      setCoupon("");
      setAppliedCoupon("");
    }
    setSelectedVariant(variant);
  };

  React.useLayoutEffect(() => {
    localStorage.setItem("supcoursename", "supcoursenameremove");
    localStorage.setItem("supcourseid", "supcourseidremove");
    getUserProfile();
    // eslint-disable-next-line
  }, [flag]);

  React.useEffect(() => {
    if (isSameAddress) {
      const { THouseNo, TStreet, TLandmark, TCity, TState, TZipCode } =
        userData;
      setUserData({
        ...userData,
        PHouseNo: THouseNo,
        PStreet: TStreet,
        PLandmark: TLandmark,
        PCity: TCity,
        PState: TState,
        PZipCode: TZipCode,
      });
    } else {
      setUserData({
        ...userData,
        PHouseNo: "",
        PStreet: "",
        PLandmark: "",
        PCity: "",
        PState: "",
        PZipCode: "",
      });
    }
    // eslint-disable-next-line
  }, [isSameAddress]);

  React.useEffect(() => {
    if (courseDetails.tabCompulsory === 0) {
      getBillingCourseDetail(coupon, debouncedTablet ? 1 : 0);
    }
    // eslint-disable-next-line
  }, [debouncedTablet]);

  React.useLayoutEffect(() => {
    const getAllCoupons = async () => {
      try {
        const res = await getCoupons({ courseid: courseId });
        if (res.code === 200) {
          setCouponList(res.data.coupans.rows || []);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      }
    };

    const getMainBillingCourseDetail = async () => {
      try {
        const selectedAddons = addons[courseId];
        setLoading(true);
        const res = await getBillingCourseDetailById({
          courseid: courseId,
          addon_ids: selectedAddons?.map((data) => data.id),
        });

        if (res.code === 200) {
          const data = res.data.data || {};
          setCourseDetails(data);
          setTabData(res.data.tabData || []);

          // ✅ Auto-select variant: pehle location.state se match karo, warna pehla variant
          const variants = data.courseVariants || [];
          if (variants.length > 0) {
            const passedVariantId = location.state?.variantId;
            if (passedVariantId) {
              const matched = variants.find((v) => v.id === passedVariantId);
              setSelectedVariant(matched || variants[0]);
            } else {
              setSelectedVariant(variants[0]);
            }
          }

          setLoading(false);
        } else {
          failResponse(res);
          setLoading(false);
          getBillingCourseDetail();
        }
      } catch (err) {
        setLoading(false);
        errorResponse(err);
      }
    };

    getAllCoupons();
    getMainBillingCourseDetail();
    // eslint-disable-next-line
  }, [courseId]);

  React.useLayoutEffect(() => {
    if (navType !== "PUSH") {
      navigate(`/course-detail/${courseName}/${courseId}`);
    }
    // eslint-disable-next-line
  }, [navType, navigate]);

  const [allStates, setallStates] = useState([]);
  const [selectedTState, setSelectedTState] = useState("");
  const [selectedPState, setSelectedPState] = useState("");

  React.useLayoutEffect(() => {
    localStorage.setItem("supcoursename", "supcoursenameremove");
    localStorage.setItem("supcourseid", "supcourseidremove");
    const getAllStatesList = async () => {
      try {
        const res = await getAllStates();
        if (res.code === 200) {
          setallStates(res.data.stateslist.rows || []);
        } else {
          toast.error(res.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
      }
    };
    getAllStatesList();
    // eslint-disable-next-line
  }, []);

  const handleTStateChange = (e) => {
    setSelectedTState(e.target.value);
    setUserData({ ...userData, TState: e.target.value });
  };

  const handlePStateChange = (e) => {
    setSelectedPState(e.target.value);
    setUserData({ ...userData, PState: e.target.value });
  };

  const handleLogForSubscriptionDetails = async () => {
    try {
      const res = await websiteVisitPageLog({
        courseid: courseId,
        coursetitle: courseName,
        pagename: "CourseSubscription",
      });
      if (res.code === 200) {
      } else {
        failResponse(res);
      }
    } catch (err) {
      errorResponse(err);
    }
  };

  useLayoutEffect(() => {
    if (isEffectRun.current) return;
    isEffectRun.current = true;
    if (isLoggedIn()) {
      handleLogForSubscriptionDetails();
    }
  }, []);

  const getNewDesignTotal = () => {
    const feesData = courseDetails?.courseFeesData;
    if (!feesData) return courseDetails.total;
    if (selectedDevice === "tab")
      return parseFloat(feesData.tabnewstudentfees || 0);
    if (selectedDevice === "mob")
      return parseFloat(feesData.mobnewstudentfees || 0);
    if (selectedDevice === "byod")
      return parseFloat(feesData.byodnewstudentfees || 0);
    return courseDetails.total;
  };

  // ✅ Helper: variant features array
  const getVariantFeatures = (variant) => {
    return [
      variant.feature1,
      variant.feature2,
      variant.feature3,
      variant.feature4,
      variant.feature5,
      variant.feature6,
      variant.feature7,
    ].filter(Boolean);
  };

  return (
    <>
      <div className="breadcrumb">
        <div className="container">
          <ul>
            <li>
              <Link to="/course-listing">Course listing</Link>
            </li>
            <li>
              <Link to={`/course-detail/${courseName}/${courseId}`}>
                Course details
              </Link>
            </li>
            <li>
              <Link to="#">Payment summary</Link>
            </li>
          </ul>
        </div>
      </div>

      <section className="course_subscription spacing">
        <div className="container">
          {loading && <CourseSubscriptionSkeleton />}

          {!loading && (
            <div className="subscription_content">
              <div className="personal_details">
                <h6>Subscribe</h6>
                <div className="form_group">
                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Input
                        type="text"
                        name="firstName"
                        value={userData.firstName || ""}
                        onChange={onChangeHandler}
                        placeholder="Enter First Name"
                        className={`input form-control`}
                        maxLength={50}
                        label={"First Name "}
                        error={errorField.firstName || ""}
                        required
                      />
                    </div>

                    <div className="form_field">
                      <Input
                        type="text"
                        name="middleName"
                        placeholder="Enter Middle Name"
                        className={`input form-control `}
                        label={"Middle Name"}
                        value={userData.middleName || ""}
                        onChange={onChangeHandler}
                        maxLength={50}
                      />
                    </div>

                    {userData.lastName ? (
                      <div className="form_field">
                        <Input
                          type="text"
                          name="lastName"
                          placeholder="Enter Last Name"
                          className={`input form-control `}
                          label={"Last Name"}
                          value={userData.lastName || ""}
                          onChange={onChangeHandler}
                          maxLength={50}
                          error={errorField.lastName || ""}
                          required
                        />
                      </div>
                    ) : (
                      <div className="form_field">
                        <Input
                          type="text"
                          name="lastName"
                          placeholder="Enter Last Name"
                          className={`input form-control `}
                          label={"Last Name"}
                          onChange={onChangeHandler}
                          maxLength={50}
                          error={errorField.lastName || ""}
                          required
                        />
                      </div>
                    )}
                  </div>

                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Input
                        type="text"
                        name="Mobile"
                        placeholder="Enter Mobile"
                        className={`input form-control ${mobError && "is-invalid"}`}
                        maxLength={10}
                        value={userData.Mobile || ""}
                        onChange={onChangeHandler}
                        label={"Mobile Number "}
                        error={errorField.Mobile}
                        required
                        readOnly={userData.mobileVerified === true}
                      />
                      {mobError && (
                        <span
                          className="error"
                          style={{
                            color: "#dc3545",
                            fontSize: "13px",
                            marginLeft: "1px",
                          }}
                        >
                          {mobError}
                        </span>
                      )}
                    </div>

                    <div className="form_field">
                      <Input
                        type="text"
                        name="EmergencyContactNo"
                        placeholder="Enter Emergency Contact No"
                        className={`input form-control ${emobError && "is-invalid"}`}
                        value={userData.EmergencyContactNo || ""}
                        maxLength={10}
                        onChange={onChangeHandler}
                        label={"Emergency Number "}
                        error={errorField.EmergencyContactNo}
                        required
                      />
                      {emobError && (
                        <span
                          className="error"
                          style={{
                            color: "#dc3545",
                            fontSize: "13px",
                            marginLeft: "1px",
                          }}
                        >
                          {emobError}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Input
                        type="text"
                        name="EmailID"
                        value={userData.EmailID || ""}
                        placeholder="Enter Email Id"
                        className={`input form-control `}
                        maxLength={50}
                        label={"E-mail id "}
                        error={errorField.EmailID}
                        required
                        readOnly
                      />
                    </div>

                    {userData.Education ? (
                      <div className="form_field">
                        <Input
                          type="text"
                          name="Education"
                          value={userData.Education || ""}
                          onChange={onChangeHandler}
                          placeholder="Enter Education"
                          className={`input form-control `}
                          maxLength={50}
                          label={"Education "}
                          error={errorField.Education}
                          required
                        />
                      </div>
                    ) : (
                      <div className="form_field">
                        <Input
                          type="text"
                          name="Education"
                          onChange={onChangeHandler}
                          placeholder="Enter Education"
                          className={`input form-control `}
                          maxLength={50}
                          label={"Education "}
                          error={errorField.Education}
                          required
                        />
                      </div>
                    )}
                  </div>
                </div>

                <br />
                <br />
                {/*
                ===================== DOCUMENTS SECTION (HIDDEN) =====================
                Hidden from UI as requested. Logic, state and API payload are
                left untouched — only the visual rendering is commented out.

                <h6>Documents</h6>
                <div className="form_group" style={{ padding: "0px" }}>
                  <div className="dashboard edit_profile">
                    <div className="edit_profile_content">
                      <div className="profile_content">
                        <UploadCourseSubScription
                          addressDoc={userData.addressProof || ""}
                          idDoc={userData.IDProof || ""}
                          idPhoto={userData.IDPhoto || ""}
                          DOBCertificate={userData.DOBCertificate || ""}
                          HSCCertificate={userData.HSCCertificate || ""}
                          isEditable={isEditable}
                          flag={() => setFlag(!flag)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                ===================== END DOCUMENTS SECTION =====================
                */}

                {/*
                ===================== ADDRESS SECTION (HIDDEN) =====================
                Hidden from UI as requested. Logic, state and API payload are
                left untouched — only the visual rendering is commented out.

                <h6>Address</h6>
                <div className="form_group">
                  <b className="_title">Present address</b>
                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Input
                        type="text"
                        name="THouseNo"
                        value={userData.THouseNo || ""}
                        placeholder="Enter House No."
                        onChange={onChangeHandler}
                        className={`input form-control `}
                        maxLength={20}
                        label={"House No. "}
                        error={errorField.THouseNo}
                        required
                      />
                    </div>
                    <div className="form_field">
                      <Input
                        type="text"
                        name="TStreet"
                        value={userData.TStreet || ""}
                        placeholder="Enter Street Name"
                        className={`input form-control `}
                        maxLength={20}
                        onChange={onChangeHandler}
                        label={"Street Name "}
                        error={errorField.TStreet}
                        required
                      />
                    </div>
                  </div>

                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Input
                        type="text"
                        name="TLandmark"
                        value={userData.TLandmark || ""}
                        placeholder="Enter Landmark"
                        className={`input form-control `}
                        onChange={onChangeHandler}
                        maxLength={30}
                        label={"Landmark "}
                        error={errorField.TLandmark}
                        required
                      />
                    </div>
                    <div className="form_field">
                      <Input
                        type="text"
                        name="TZipCode"
                        value={userData.TZipCode || ""}
                        placeholder="Enter Zipcode"
                        className={`input form-control `}
                        maxLength={6}
                        label={"Zipcode "}
                        error={errorField.TZipCode}
                        onChange={onChangeHandler}
                        required
                      />
                    </div>
                  </div>

                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Select
                        name="TState"
                        value={userData.TState || ""}
                        onChange={onChangeHandler}
                        className={`input form-control`}
                        label={"State "}
                      >
                        <option value="">Select State</option>
                        {allStates.map((state) => (
                          <option key={state.StateID} value={state.StateName}>
                            {state.StateName}
                          </option>
                        ))}
                      </Select>
                      {errorField.TState && (
                        <span className="error">{errorField.TState}</span>
                      )}
                    </div>
                    <div className="form_field">
                      <Input
                        type="text"
                        name="TCity"
                        value={userData.TCity || ""}
                        placeholder="Enter City"
                        onChange={onChangeHandler}
                        className={`input form-control `}
                        maxLength={20}
                        label={"City "}
                        error={errorField.TCity}
                        required
                      />
                    </div>
                  </div>
                  <p className="checkbox_wrap">
                    <Input
                      type="checkbox"
                      className="input"
                      id="check"
                      checked={isSameAddress}
                      onChange={() => {
                        setIsSameAddress(!isSameAddress);
                      }}
                    />
                    <label htmlFor="check">
                      Permanent Address same as Present Address
                    </label>
                  </p>
                  <b className="_title">Permanent address</b>
                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Input
                        type="text"
                        name="PHouseNo"
                        value={userData.PHouseNo || ""}
                        placeholder="Enter House No."
                        onChange={onChangeHandler}
                        className={`input form-control `}
                        maxLength={20}
                        label={"House No. "}
                        error={errorField.PHouseNo}
                        required
                        disabled={isSameAddress}
                      />
                    </div>
                    <div className="form_field">
                      <Input
                        type="text"
                        name="PStreet"
                        value={userData.PStreet || ""}
                        placeholder="Enter Street Name"
                        onChange={onChangeHandler}
                        className={`input form-control `}
                        maxLength={20}
                        label={"Street Name "}
                        error={errorField.PStreet}
                        required
                        disabled={isSameAddress}
                      />
                    </div>
                  </div>

                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Input
                        type="text"
                        name="PLandmark"
                        value={userData.PLandmark || ""}
                        placeholder="Enter Landmark"
                        className={`input form-control `}
                        onChange={onChangeHandler}
                        maxLength={30}
                        label={"Landmark "}
                        error={errorField.PLandmark}
                        required
                        disabled={isSameAddress}
                      />
                    </div>
                    <div className="form_field">
                      <Input
                        type="text"
                        name="PZipCode"
                        value={userData.PZipCode || ""}
                        placeholder="Enter Zipcode"
                        onChange={onChangeHandler}
                        className={`input form-control `}
                        maxLength={6}
                        label={"Zipcode "}
                        error={errorField.PZipCode}
                        required
                        disabled={isSameAddress}
                      />
                    </div>
                  </div>

                  <div className="form_field_wrap">
                    <div className="form_field">
                      <Select
                        name="PState"
                        value={userData.PState || ""}
                        onChange={onChangeHandler}
                        className={`input form-control`}
                        required
                        label={"State"}
                      >
                        <option value="">Select State</option>
                        {allStates.map((state) => (
                          <option key={state.StateID} value={state.StateName}>
                            {state.StateName}
                          </option>
                        ))}
                      </Select>
                      {errorField.PState && (
                        <span className="error">{errorField.PState}</span>
                      )}
                    </div>
                    <div className="form_field">
                      <Input
                        type="text"
                        name="PCity"
                        value={userData.PCity || ""}
                        onChange={onChangeHandler}
                        placeholder="Enter City"
                        className={`input form-control `}
                        maxLength={20}
                        label={"City "}
                        error={errorField.PCity}
                        disabled={isSameAddress}
                        required
                      />
                    </div>
                  </div>
                </div>
                ===================== END ADDRESS SECTION =====================
                */}
              </div>

              {/* ======================== RIGHT SIDE: Summary ======================== */}
              <div className="course_detail">
                <h6>Summary</h6>
                <div className="form_group">
                  {+courseDetails?.purchased === 1 ? (
                    <>
                      <div className="already_purchased">
                        <img src={CourseBookImg} alt="" loading="lazy" />
                        <h4>You have already purchased this course.</h4>
                      </div>
                    </>
                  ) : (
                    <>
                      {/* ===================== VARIANT FLOW ===================== */}
                      {hasVariants ? (
                        <>
                          <h5>{courseDetails.title}</h5>

                          {/* Step 1: Select variant */}
                          <div className="device_selection_section">
                            <p className="device_selection_label">
                              <b>1. Select course variant</b>
                            </p>
                            <p className="device_selection_sublabel">
                              Choose the variant that suits you best
                            </p>

                            <div className="device_options_list">
                              {courseVariantsList.map((variant) => (
                                <div
                                  key={variant.id}
                                  className={`device_option_card ${selectedVariant?.id === variant.id ? "selected" : ""}`}
                                  onClick={() => handleVariantSelect(variant)}
                                >
                                  <div className="device_option_left">
                                    <input
                                      type="radio"
                                      name="variantOption"
                                      checked={
                                        selectedVariant?.id === variant.id
                                      }
                                      onChange={() => handleVariantSelect(variant)}
                                    />
                                    <div className="device_option_info">
                                      <b>{variant.variantname}</b>
                                      <span>{variant.description}</span>
                                    </div>
                                  </div>
                                <div className="device_option_price">
  {courseDetails.isOldStudent === 1 ? (
    // Old student: Show oldstdprice as final, newstdprice as strikethrough
    <>
      <del style={{ color: "#999", fontSize: "13px" }}>
        ₹ {parseFloat(variant.newstdprice).toLocaleString("en-IN")}
      </del>
      <br />
      ₹ {parseFloat(variant.oldstdprice).toLocaleString("en-IN")}
    </>
  ) : (
    // New student: Show newstdprice only
    `₹ ${parseFloat(variant.newstdprice).toLocaleString("en-IN")}`
  )}
</div>
                                </div>
                              ))}
                            </div>
                          </div>

                          {/* Step 2: Coupon code */}
                          <div className="couponcode">
                            <p className="device_selection_label">
                              <b>2. Coupon code</b>
                            </p>
                            <div className="applyCoupon">
                              <div className="input_wrap">
                                <input
                                  type="text"
                                  placeholder="Enter coupon code"
                                  value={coupon}
                                  onChange={(e) => setCoupon(e.target.value)}
                                  maxLength={20}
                                />
                                <button
                                  type="button"
                                  ref={buttonRef}
                                  onClick={() => couponApplyHandler(coupon)}
                                >
                                  Apply
                                </button>
                              </div>
                            </div>
                            {couponList && couponList.length > 0 && (
                              <div className="couponCodeListing">
                                <p>
                                  <span
                                    onClick={() =>
                                      setCouponToggle(!couponToggle)
                                    }
                                  >
                                    {couponToggle
                                      ? "Hide Coupons"
                                      : "Show Coupons"}
                                  </span>
                                </p>
                                {couponToggle && (
                                  <ul>
                                    {couponList?.map((couponData, index) => (
                                      <li
                                        className={`${couponData.couponcode?.toLowerCase() === appliedCoupon?.toLowerCase() ? "applied" : ""}`}
                                        key={index}
                                      >
                                        <span className="coupon">
                                          {couponData.couponcode}
                                        </span>
                                        <div className="button_wrap">
                                          <button
                                            onClick={() =>
                                              couponApplyHandler(
                                                couponData.couponcode,
                                              )
                                            }
                                          >
                                            {couponData.couponcode?.toLowerCase() ===
                                            appliedCoupon?.toLowerCase()
                                              ? "Applied"
                                              : "Apply"}
                                          </button>
                                          {couponData.couponcode?.toLowerCase() ===
                                            appliedCoupon?.toLowerCase() && (
                                            <span
                                              className="delete_coupon"
                                              onClick={() => {
                                                getBillingCourseDetail(
                                                  "",
                                                  0,
                                                  selectedVariant?.variantcode ||
                                                    null
                                                );
                                                setCoupon("");
                                                setAppliedCoupon("");
                                              }}
                                            >
                                              <FaTimesCircle />
                                            </span>
                                          )}
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            )}
                          </div>

                          {/* ✅ NEW: coupon discount line */}
                          {isVariantCouponApplied && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                margin: "10px 0",
                                color: "#1a8f3c",
                                fontSize: "14px",
                              }}
                            >
                              <span>
                                Coupon applied: {courseDetails.couponCode}
                              </span>
                              <b>
                                - ₹{" "}
                                {parseFloat(
                                  courseDetails.couponCodeAmount || 0
                                ).toLocaleString("en-IN")}
                              </b>
                            </div>
                          )}

                          <div className="total_amount">
                            <div>
                              <b>Total amount</b>
                              <div
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "400",
                                  color: "#666",
                                }}
                              >
                                (Includes all applicable taxes)
                              </div>
                            </div>
                            <b>
                              {selectedVariant
                                ? `₹ ${parseFloat(effectiveTotal).toLocaleString("en-IN")}`
                                : "—"}
                            </b>
                          </div>

                          {/* Payment */}
                          <Payment
                            isEditable={isEditable}
                            handleValidation={handleValidation}
                            userData={userData}
                            courseId={courseId}
                            affiliateCenterNo={centerid}
                            courseDetails={{
                              ...courseDetails,
                              total: effectiveTotal,
                            }}
                            buttonRef={buttonRef2}
                            setButtonLoading={setButtonLoading2}
                            selectedDevice={null}
                            selectedVariantId={
                              selectedVariant?.variantcode || null
                            }
                          />
                        </>
                      ) : courseDetails?.courseFeesData ? (
                        /* ===================== NEW DESIGN: courseFeesData exists ===================== */
                        <>
                          <h5>{courseDetails.title}</h5>

                          <div className="device_selection_section">
                            <p className="device_selection_label">
                              <b>1. Select device option</b>
                            </p>
                            <p className="device_selection_sublabel">
                              Choose the device you will use for this course
                            </p>

                            <div className="device_options_list">
                              {/* Tablet */}
                              <div
                                className={`device_option_card ${selectedDevice === "tab" ? "selected" : ""}`}
                                onClick={() => setSelectedDevice("tab")}
                              >
                                <div className="device_option_left">
                                  <input
                                    type="radio"
                                    name="deviceOption"
                                    checked={selectedDevice === "tab"}
                                    onChange={() => setSelectedDevice("tab")}
                                  />
                                  <div className="device_option_icon">
                                    <svg
                                      width="32"
                                      height="40"
                                      viewBox="0 0 32 40"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect
                                        x="1"
                                        y="1"
                                        width="30"
                                        height="38"
                                        rx="3"
                                        stroke="#333"
                                        strokeWidth="2"
                                        fill="none"
                                      />
                                      <rect
                                        x="4"
                                        y="5"
                                        width="24"
                                        height="27"
                                        rx="1"
                                        stroke="#333"
                                        strokeWidth="1.2"
                                        fill="none"
                                      />
                                      <circle
                                        cx="16"
                                        cy="36"
                                        r="1.5"
                                        fill="#333"
                                      />
                                    </svg>
                                  </div>
                                  <div className="device_option_info">
                                    <b>Tablet</b>
                                    <span>
                                      {
                                        courseDetails.courseFeesData
                                          ?.tabdescription
                                      }
                                    </span>
                                  </div>
                                </div>
                                <div className="device_option_price">
                                  ₹{" "}
                                  {parseFloat(
                                    courseDetails.courseFeesData
                                      .tabnewstudentfees || 0,
                                  ).toLocaleString("en-IN")}
                                </div>
                              </div>

                              {/* Mobile */}
                              {courseDetails.courseFeesData
                                .mobnewstudentfees && (
                                <div
                                  className={`device_option_card ${selectedDevice === "mob" ? "selected" : ""}`}
                                  onClick={() => setSelectedDevice("mob")}
                                >
                                  <div className="device_option_left">
                                    <input
                                      type="radio"
                                      name="deviceOption"
                                      checked={selectedDevice === "mob"}
                                      onChange={() => setSelectedDevice("mob")}
                                    />
                                    <div className="device_option_icon">
                                      <svg
                                        width="24"
                                        height="40"
                                        viewBox="0 0 24 40"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <rect
                                          x="1"
                                          y="1"
                                          width="22"
                                          height="38"
                                          rx="3"
                                          stroke="#333"
                                          strokeWidth="2"
                                          fill="none"
                                        />
                                        <rect
                                          x="4"
                                          y="5"
                                          width="16"
                                          height="27"
                                          rx="1"
                                          stroke="#333"
                                          strokeWidth="1.2"
                                          fill="none"
                                        />
                                        <circle
                                          cx="12"
                                          cy="36"
                                          r="1.5"
                                          fill="#333"
                                        />
                                      </svg>
                                    </div>
                                    <div className="device_option_info">
                                      <b>Mobile</b>
                                      <span>
                                        {
                                          courseDetails.courseFeesData
                                            ?.mobdescription
                                        }
                                      </span>
                                    </div>
                                  </div>
                                  <div className="device_option_price">
                                    ₹{" "}
                                    {parseFloat(
                                      courseDetails.courseFeesData
                                        .mobnewstudentfees || 0,
                                    ).toLocaleString("en-IN")}
                                  </div>
                                </div>
                              )}

                              {/* BYOD */}
                              {courseDetails.courseFeesData
                                .byodnewstudentfees && (
                                <div
                                  className={`device_option_card ${selectedDevice === "byod" ? "selected" : ""}`}
                                  onClick={() => setSelectedDevice("byod")}
                                >
                                  <div className="device_option_left">
                                    <input
                                      type="radio"
                                      name="deviceOption"
                                      checked={selectedDevice === "byod"}
                                      onChange={() => setSelectedDevice("byod")}
                                    />
                                    <div className="device_option_icon">
                                      <svg
                                        width="28"
                                        height="40"
                                        viewBox="0 0 28 40"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <rect
                                          x="1"
                                          y="1"
                                          width="26"
                                          height="38"
                                          rx="3"
                                          stroke="#333"
                                          strokeWidth="2"
                                          fill="none"
                                        />
                                        <rect
                                          x="4"
                                          y="5"
                                          width="20"
                                          height="27"
                                          rx="1"
                                          stroke="#333"
                                          strokeWidth="1.2"
                                          fill="none"
                                        />
                                        <circle
                                          cx="14"
                                          cy="36"
                                          r="1.5"
                                          fill="#333"
                                        />
                                        <path
                                          d="M9 16 L14 11 L19 16"
                                          stroke="#333"
                                          strokeWidth="1.2"
                                          fill="none"
                                        />
                                        <path
                                          d="M14 11 L14 22"
                                          stroke="#333"
                                          strokeWidth="1.2"
                                        />
                                        <rect
                                          x="9"
                                          y="22"
                                          width="10"
                                          height="3"
                                          rx="0.5"
                                          stroke="#333"
                                          strokeWidth="1"
                                          fill="none"
                                        />
                                      </svg>
                                    </div>
                                    <div className="device_option_info">
                                      <b>BYOD (Bring your own device)</b>
                                      <span>
                                        {
                                          courseDetails.courseFeesData
                                            ?.byoddescription
                                        }
                                      </span>
                                    </div>
                                  </div>
                                  <div className="device_option_price">
                                    ₹{" "}
                                    {parseFloat(
                                      courseDetails.courseFeesData
                                        .byodnewstudentfees || 0,
                                    ).toLocaleString("en-IN")}
                                  </div>
                                </div>
                              )}
                            </div>

                            {selectedDevice === "byod" &&
                              courseDetails.courseFeesData
                                .byodnewstudentfees && (
                                <div className="byod_note_box">
                                  <span className="byod_note_icon">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="10"
                                        cy="10"
                                        r="9"
                                        fill="#4971b2"
                                      />
                                      <text
                                        x="10"
                                        y="15"
                                        textAnchor="middle"
                                        fill="white"
                                        fontSize="12"
                                        fontWeight="bold"
                                      >
                                        i
                                      </text>
                                    </svg>
                                  </span>
                                  <span>
                                    <b>Note: </b>You can bring your own Samsung
                                    mobile device or tablet device which are
                                    eligible to be enrolled in Samsung Knox
                                    System. You have to provide IMEI number to
                                    get it enrolled. Device will be locked for
                                    the duration of the subscription.
                                  </span>
                                </div>
                              )}
                          </div>

                          <div className="couponcode">
                            <p className="device_selection_label">
                              <b>2. Coupon code</b>
                            </p>
                            <div className="applyCoupon">
                              <div className="input_wrap">
                                <input
                                  type="text"
                                  placeholder="Enter coupon code"
                                  value={coupon}
                                  onChange={(e) => setCoupon(e.target.value)}
                                  maxLength={20}
                                />
                                <button
                                  type="button"
                                  ref={buttonRef}
                                  onClick={() => couponApplyHandler(coupon)}
                                >
                                  Apply
                                </button>
                              </div>
                            </div>
                            {couponList && couponList.length > 0 && (
                              <div className="couponCodeListing">
                                <p>
                                  <span
                                    onClick={() =>
                                      setCouponToggle(!couponToggle)
                                    }
                                  >
                                    {couponToggle
                                      ? "Hide Coupons"
                                      : "Show Coupons"}
                                  </span>
                                </p>
                                {couponToggle && (
                                  <ul>
                                    {couponList?.map((couponData, index) => (
                                      <li
                                        className={`${couponData.couponcode?.toLowerCase() === appliedCoupon?.toLowerCase() ? "applied" : ""}`}
                                        key={index}
                                      >
                                        <span className="coupon">
                                          {couponData.couponcode}
                                        </span>
                                        <div className="button_wrap">
                                          <button
                                            onClick={() =>
                                              couponApplyHandler(
                                                couponData.couponcode,
                                              )
                                            }
                                          >
                                            {couponData.couponcode?.toLowerCase() ===
                                            appliedCoupon?.toLowerCase()
                                              ? "Applied"
                                              : "Apply"}
                                          </button>
                                          {couponData.couponcode?.toLowerCase() ===
                                            appliedCoupon?.toLowerCase() && (
                                            <span
                                              className="delete_coupon"
                                              onClick={() => {
                                                getBillingCourseDetail();
                                                setCoupon("");
                                                setAppliedCoupon("");
                                              }}
                                            >
                                              <FaTimesCircle />
                                            </span>
                                          )}
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="total_amount">
                            <div>
                              <b>Total amount</b>
                              <div
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "400",
                                  color: "#666",
                                }}
                              >
                                (Includes all applicable taxes)
                              </div>
                            </div>
                            <b>
                              ₹ {getNewDesignTotal().toLocaleString("en-IN")}
                            </b>
                          </div>

                          <Payment
                            isEditable={isEditable}
                            handleValidation={handleValidation}
                            userData={userData}
                            courseId={courseId}
                            affiliateCenterNo={centerid}
                            courseDetails={{
                              ...courseDetails,
                              total: getNewDesignTotal(),
                            }}
                            buttonRef={buttonRef2}
                            setButtonLoading={setButtonLoading2}
                            selectedDevice={
                              courseDetails?.courseFeesData
                                ? selectedDevice
                                : null
                            }
                          />
                        </>
                      ) : (
                        /* ===================== OLD DESIGN ===================== */
                        <>
                          <h5>{courseDetails.title}</h5>
                          <ul className="course_bill_summary">
                            <li>
                              <span>Course Fees :</span>
                              {courseDetails.isOldStudent === 1 ? (
                                <del>
                                  <b>
                                    <BiRupee /> {courseDetails.courseFee}
                                  </b>
                                </del>
                              ) : (
                                <b>
                                  <BiRupee /> {courseDetails.courseFee}
                                </b>
                              )}
                            </li>
                            {courseDetails.isOldStudent === 1 && (
                              <li>
                                <span>SR old student fee:</span>
                                <b>
                                  <BiRupee />{" "}
                                  {courseDetails.oldStudentCourseFee}
                                </b>
                              </li>
                            )}
                            {courseDetails.tabCompulsory === 0 && !tablet && (
                              <li>
                                <span>Tablet Price</span>
                                <del>
                                  <b>
                                    <BiRupee /> {courseDetails.tabPrice}
                                  </b>
                                </del>
                              </li>
                            )}

                            {addons[courseId] &&
                              addons[courseId]?.length > 0 && (
                                <div className="my-2">
                                  <h6 className="">Addons</h6>
                                  {addons[courseId]?.map((addon) => (
                                    <li key={addon.id}>
                                      <span>{addon.name || "N/A"} :</span>
                                      <b>
                                        <BiRupee />
                                        {addon.price}
                                      </b>
                                    </li>
                                  ))}
                                </div>
                              )}

                            {courseDetails.couponCodeApplied === 1 && (
                              <li>
                                <span>
                                  Coupon : {courseDetails.couponCode}{" "}
                                </span>
                                <b>
                                  <BiRupee />
                                  {courseDetails.couponCodeAmount}
                                </b>
                              </li>
                            )}
                          </ul>
                          <div className="couponcode">
                            <div className="applyCoupon">
                              <b>Coupon code</b>
                              <div className="input_wrap">
                                <input
                                  type="text"
                                  placeholder="Enter coupon code"
                                  value={coupon}
                                  onChange={(e) => setCoupon(e.target.value)}
                                  maxLength={20}
                                />
                                <button
                                  type="button"
                                  ref={buttonRef}
                                  onClick={() => couponApplyHandler(coupon)}
                                >
                                  Apply
                                </button>
                              </div>
                            </div>
                            {couponList && couponList.length > 0 && (
                              <div className="couponCodeListing">
                                <p>
                                  <span
                                    onClick={() =>
                                      setCouponToggle(!couponToggle)
                                    }
                                  >
                                    {couponToggle
                                      ? "Hide Coupons"
                                      : "Show Coupons"}
                                  </span>
                                </p>
                                {couponToggle && (
                                  <ul>
                                    {couponList?.map((couponData, index) => (
                                      <li
                                        className={`${couponData.couponcode?.toLowerCase() === appliedCoupon?.toLowerCase() ? "applied" : ""}`}
                                        key={index}
                                      >
                                        <span className="coupon">
                                          {couponData.couponcode}
                                        </span>
                                        <div className="button_wrap">
                                          <button
                                            onClick={() =>
                                              couponApplyHandler(
                                                couponData.couponcode,
                                              )
                                            }
                                          >
                                            {couponData.couponcode?.toLowerCase() ===
                                            appliedCoupon?.toLowerCase()
                                              ? "Applied"
                                              : "Apply"}
                                          </button>
                                          {couponData.couponcode?.toLowerCase() ===
                                            appliedCoupon?.toLowerCase() && (
                                            <span
                                              className="delete_coupon"
                                              onClick={() => {
                                                getBillingCourseDetail();
                                                setCoupon("");
                                                setAppliedCoupon("");
                                              }}
                                            >
                                              <FaTimesCircle />
                                            </span>
                                          )}
                                        </div>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                            )}
                          </div>
                          <div className="total_amount">
                            <b>Total amount</b>
                            <b>
                              <BiRupee /> {courseDetails.total}
                            </b>
                          </div>

                          {courseDetails.coursePlatform?.includes("Tablet") && (
                            <div className="tab_devices_list">
                              <ul>
                                {tabData &&
                                  tabData.map((data) => (
                                    <li
                                      className={`tab_item ${data.TabStatus === "Inactive" ? "inactive" : "active"}`}
                                      key={data.TabStudentid}
                                    >
                                      <div className="content">
                                        <FcTabletAndroid />
                                        <b>{data.TabName}</b>
                                        <span className="IMEINumber">
                                          {data.IMEINumber}
                                        </span>
                                      </div>
                                      <span
                                        className={`status ${data.TabStatus === "Inactive" ? "inactive" : "active"}`}
                                      ></span>
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          )}

                          {+courseDetails.tabCompulsory === 0 &&
                            courseDetails.coursePlatform?.includes(
                              "Tablet",
                            ) && (
                              <label className="check_box_wrap pb-0">
                                <input
                                  type="checkbox"
                                  checked={tablet}
                                  onChange={({ target }) =>
                                    setTablet(target.checked)
                                  }
                                />
                                Do you want to purchase tablet ?
                              </label>
                            )}

                          <Payment
                            isEditable={isEditable}
                            handleValidation={handleValidation}
                            userData={userData}
                            courseId={courseId}
                            affiliateCenterNo={centerid}
                            courseDetails={courseDetails}
                            buttonRef={buttonRef2}
                            setButtonLoading={setButtonLoading2}
                            selectedDevice={null}
                          />
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default CourseSubscription;